<template>
  <div>
    <el-dialog
      title="Cambio Fecha de Compromiso"
      :visible.sync="isItVisible"
      @open="OnOpeningDialog"
      @close="handleClose"
      width="30%"
    >
      <el-form :model="form">
        <el-form-item
          label="Fecha de compromiso actual:"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="form.ActualDate"
            type="date"
            placeholder="Seleccione una fecha"
            disabled
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="Fecha de compromiso nueva:"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="form.NewDate"
            type="date"
            placeholder="Seleccione una fecha"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="Fijar en Reportede tareas"
          class="formItemTopPad"
          prop="fixed"
        >
          <el-checkbox
            size="medium"
            v-model="form.fixed"
            :checked="form.fixed"
            @change="onFixedChange"
            >Fija?
          </el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="SendNewDate">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ChangeTaskDueDate",
  props: {
    DueDateDialogVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    ActualTaskInfo: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  data() {
    return {
      form: {
        ActualDate: "",
        NewDate: "",
        fixed: false,
        formLabelWidth: "300px"
      }
    };
  },
  computed: {
    // Define your computed properties here
    isItVisible() {
      return this.DueDateDialogVisible;
    }
  },
  methods: {
    // Define your methods here
    handleClose() {
      this.form.NewDate = "";
      this.$emit("ClosingDueDateDialog", false);
    },
    OnOpeningDialog() {
      this.form.ActualDate = this.ActualTaskInfo?.DueDate || "";
      this.form.fixed = this.ActualTaskInfo?.IsFixed || false;
    },
    async SendNewDate() {
      if (this.form.NewDate) {
        await this.$http
          .put("/api/ReporteGestion/ChangeDueDate", {
            Id: this.ActualTaskInfo.OriginalID,
            Task: this.ActualTaskInfo.ID,
            DueDate: this.form.NewDate,
            IsFixed: this.form.fixed,
            ResponsibleId: this.ActualTaskInfo.ResponsableID
          })
          .then(async () => {
            this.$emit("NewDueDateUpdated");
          });
      } else {
        this.$message.error("Por favor, seleccione una nueva fecha.");
      }
    },
    onFixedChange(val) {
      this.form.fixed = val;
    }
  }
};
</script>

<style lang="scss" scoped></style>
